module.exports = __webpack_public_path__ + "img/trade@2x.80201dfc.jpg";